import React from 'react';

const ArchiveIcon: React.FC = (): React.ReactElement => {
  return (
    <>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.75 1.625H2.25H1.125V2.75V5.5625V6.125V6.6875H2.8125V16.25V17.375H3.9375H14.0625H15.1875V16.25V6.6875H16.875V6.125V5.5625V2.75V1.625H15.75ZM14.0625 6.6875H3.9375V16.25H14.0625V6.6875ZM15.75 2.75V5.5625H2.25V2.75H15.75ZM6.75 8.9375H11.25V10.0625H6.75V8.9375Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default ArchiveIcon;
